<template>
  <div
    v-bind:class="{ 'dockabale-window': getDockState, open: open }"
    v-show="getHasContent"
    class="dockabale-window font"
  >
    <div class="header-dockabale" @click="toggleList">
      <span class="title dir-rtl">
        <slot name="header"></slot>
      </span>
    </div>
    <div v-show="open" class="list-container">
      <div class="search" v-show="search">
        <div class="search-content">
          <div class="inner-search">
            <BaseIcon
              class="icon-search-input"
              width="11"
              height="11"
              nameIcon="icon-search-small"
              pathIcon="icons-ganeral"
            />
            <slot name="search"></slot>
          </div>
        </div>
      </div>
      <div
        tabindex="1"
        ref="list"
        class="list full-h"
        @keydown.down="down"
        @keydown.up="up"
      >
        <div class="list-content list-content-navigate full-h">
          <slot name="listContent"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "hasContent",
    "search",
    "open",
    "position",
    "scrollto",
    "book",
    "itemsCount",
    "currentItem",
    "listFocus",
  ],
  watch: {
    listFocus: function (val, oldVal) {
      this.$refs.list.focus();
    },

    itemsCount: {
      handler(val, oldVal) {
        if (this.navigatePart == 2) {
          if (val > 0) this.$emit("click", this.navigatePart, true);
          else this.$emit("click", this.navigatePart, false);
        }
      },
    },
  },
  data() {
    return {
      listItems: null,
      nameIconRemove: "x-list",
      style: "",
      showList: this.open,
      navigatePart: this.position,
    };
  },
  computed: {
    getDockState() {
      return this.dockState;
    },
    getshowCloseIcon() {
      return this.showCloseIcon ? this.showCloseIcon : false;
    },
    getHasContent() {
      return this.hasContent;
    },
  },
  methods: {
    down(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.currentItem < this.itemsCount)
        this.$emit("setActive", this.currentItem + 1, 1);
      return false;
    },
    up(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.currentItem > 0)
        this.$emit("setActive", this.currentItem - 1, -1);
      return false;
    },
    closeList() {
      this.state = false;
    },
    parentList() {
      this.$emit("click");
    },
    setDockState(state) {
      this.dockState = state;
    },
    toggleList(event) {
      let open = this.open;
      //if click comes from plus user tsiyun button - open list
      if (event.srcElement.className == "plus-tsiyun") {
        open = true;
      }
      //  this.showList = true;
      else {
        open = !this.open;
        // alert("2");
      } // this.showList = !this.showList;
      this.$emit("click", this.navigatePart, open);
    },
  },
  mounted() {
    if (this.navigatePart != 2) return;
    if (this.itemsCount > 0) this.$emit("click", this.navigatePart, true);
    else this.$emit("click", this.navigatePart, false);
  },
};
</script>

<style lang="scss">
div:focus {
  outline: none;
}
.list-content-navigate {
  .inner-empty {
    color: #707070;
    text-align: center;
    font-size: 13px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    line-height: 16px;
    span {
      display: block;
      margin: 0 auto;
    }
  }
}
.dockabale-window {
  // z-index: 1000;
  flex-direction: column;
  display: flex;
  transition: 0.3s;
  height: 0;
  flex-grow: 0;
  overflow: hidden;
  .div-icon {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    transition: 0.3s;
    margin-top: 4px;
    &:hover {
      background-color: #00000014;
    }
  }
}
.dockabale-window:not(.open) {
  height: 32px;
}
.dockabale-window.open {
  .div-icon {
    transform: rotate(180deg);
    transition: 0.3s;
  }
  .inner-empty {
    animation-name: scale-display;

    animation-delay: 0.6s;
  }
}
.dockabale-window .bottom {
  position: relative;
}
.dockabale-window .full {
  position: absolute;
}
.dockabale-window title {
  display: flex;
  flex-direction: column;
}
.dockabale-window .list-container {
  flex-direction: column;
  display: flex;
  height: calc(100% - 32px);
  position: relative;
  flex-grow: 1;
  // direction: ltr;
}
.dockabale-window .search {
  flex-basis: 35px;
  direction: rtl;
}
.dockabale-window .list {
  flex-basis: auto;
  overflow: auto;
  direction: ltr;

  .list-content {
    direction: rtl;
    flex-grow: 1;
    .item {
      font-size: 13px;
    }
  }
  .page-nav-item {
    direction: rtl;
  }
}
.dockabale-window.open {
  flex-grow: 1;
  height: 30%;
  // overflow: hidden;
}
</style>
